<template>
  <div>
    <main class="mt-3">
      <div class="container text-center">
        <div class="alert alert-danger" role="alert">
          ※ 결제가 취소되었거나 처리되지 않았습니다. ※
          <div v-if="displayMessage" class="mt-2" style="font-size:0.9rem;">
            사유: {{ displayMessage }}
          </div>
        </div>

        <div class="mt-4">
          <button class="btn btn-secondary mx-2" @click="goToMain()">메인으로</button>
          <button class="btn btn-primary mx-2" v-if="canRetry" @click="retryPayment()">다시 예약하기</button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { handlerInfo } from '../assets/js/commonFunctions'

export default {
  data() {
    return {
      failCode: "",
      failMessage: "",
      orderId: "",        // Toss가 돌려준 그대로(-1/-2 붙어있을 수 있음)
      origRCode: "",      // 예약원번(-1/-2 제거)
      productId: "",      // 재시도용
      canRetry: false,

      handTel: [],        //알림톡발송대상
      resType: "",        // SP vs 일반예약 구분
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    displayMessage() {
      const map = {
        PAY_PROCESS_CANCELED:           "결제를 취소하셨습니다.",
        PAY_PROCESS_ABORTED:            "결제 진행 중 오류가 발생했습니다.",
        REJECT_CARD_COMPANY:            "카드사에서 결제를 거절했습니다. 카드 정보를 확인해주세요.",
        INVALID_CARD_EXPIRATION:        "카드 유효기간을 확인해주세요.",
        EXCEED_MAX_DAILY_PAYMENT_COUNT: "일일 결제 한도를 초과했습니다.",
        NOT_SUPPORTED_CARD_TYPE:        "지원하지 않는 카드입니다.",
      };
      if (this.failCode && map[this.failCode]) return map[this.failCode];
      return this.failMessage || "";
    }
  },
  async created() {
    if (this.$store.state.user.handlerId != undefined) 
    {
      this.userInfo = this.$store.state.user.handlerId;
    }
    else if (this.$store.state.user.email != undefined) 
    {
      this.userInfo = this.$store.state.user.email;
    }
    else 
    {
      this.userInfo = "";
    }

    this.failCode    = this.$route.query.code || "";
    this.failMessage = this.$route.query.message || "";
    this.orderId     = this.$route.query.orderId || "";

    if (!this.orderId) return;

    this.origRCode = (this.orderId.endsWith('-1') || this.orderId.endsWith('-2'))
      ? this.orderId.slice(0, -2)
      : this.orderId;
    this.resType = this.origRCode.substring(0, 2);   // 신규: SP vs 일반예약 구분

    await this.rollbackHolds();
    let failMarked = await this.markReqPayFailed();

    if (this.resType === 'SP') 
    {
      const spFailMarked = await this.markSpayFailed();
      failMarked = failMarked || spFailMarked;
    }

    await this.fetchProductIdForRetry();

    if (failMarked) 
    {
      await this.sendFailAlim();
    }
  },

  methods: {
    goToMain() {
      this.$router.push({ path: '/' });
    },
    async retryPayment() {
      if (!this.productId) 
      {
        this.$swal.fire('', '재시도에 필요한 상품정보를 확인할 수 없습니다. 메인에서 다시 진행해주세요.', 'warning');
        return;
      }
      this.$router.push({ path: '/reservation', query: { resCode: this.origRCode, prodId: this.productId } });
    },

    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    async sendFailAlim() {
      try 
      {
        let info = null
        let pdtCode = ""
        let resPayAmount = 0

        if (this.resType === 'SP') 
        {
          const payDetailInfo = await this.$api("/api/spPayDetailInfo", { param: [this.origRCode] })
          if (!payDetailInfo || payDetailInfo.length === 0) return
          info = payDetailInfo[0]
          pdtCode = info.spResCode
          resPayAmount = info.payAmt
        } 
        else 
        {
          const payDetailInfo = await this.$api("/api/payDetailInfo", { param: [this.origRCode] })
          if (!payDetailInfo || payDetailInfo.length === 0) return
          info = payDetailInfo[0]
          pdtCode = info.reqPdtCode
          resPayAmount = info.resPayAmount
        }

        const alimFlag = "FL"   // 결제실패는 마이페이지 노출과 무관 -> 회원/비회원 구분 불필요

        //담당자연락처
        let handTel = await handlerInfo(this.$api)
        if (handTel.length > 0) this.handTel = handTel
        //고객연락처 추가
        this.handTel.push({ aimCall: info.resPhone })

        let insKSendHistory = await this.$api("/api/insKSendHistory", {
          param: [this.origRCode, alimFlag, this.userInfo || ""]
        })
        if (!insKSendHistory || insKSendHistory.affectedRows <= 0) return

        let promises = []
        for (let i = 0; i < this.handTel.length; i++) 
        {
          let kakaoAlimData = {
            clientName: info.payerName || info.clientName,
            resCode: this.origRCode,
            resName: info.spName || info.resName,
            resPrice: this.getCurrencyFormat(resPayAmount),
            failReason: this.displayMessage,
            alimFlag: alimFlag,
            alimCall: this.handTel[i].aimCall,
            pdtCode: pdtCode,
          }
          promises.push(this.$api("api/kakaoAlimSend12", { param: [{ kakaoAlimData }] }))
        }

        await Promise.all(promises).catch((error) => {
          console.log("Error calling api: ", error)
        })
      } 
      catch (error) 
      {
        console.error('sendFailAlim error:', error)
      }
    },

    async rollbackHolds() {
      try 
      {
        const veriData = await this.$api("/api/getVeriData", { param: [this.orderId] });
        if (!veriData || veriData.length === 0) return;

        const v = veriData[0];
        const email = this.user && this.user.email;
        if (!email) return; // 비회원은 포인트/쿠폰 사용대상이 아님

        if (v.payPointAmt > 0) 
        {
          await this.$api("/api/cancelPointHold", { param: [email, this.origRCode] });
        }
        if (v.payCouponAmt > 0 && v.cpCode) 
        {
          await this.$api("/api/cancelCouponHold", { param: [email, v.cpCode, v.cpSubNo, this.origRCode] });
        }
      } 
      catch (error) 
      {
        console.error('rollbackHolds error:', error);
        // 여기서 실패해도 사용자에겐 결제실패 안내만 하고, 복구는 로그로 남겨 CS가 후속조치
      }
    },
    async markReqPayFailed() {
      try 
      {
        const res = await this.$api("/api/updReqPayFail", { param: [this.orderId] });
        return res && res.affectedRows > 0;
      } 
      catch (error) 
      {
        console.error('markReqPayFailed error:', error);
        return false;
      }
    },

    async fetchProductIdForRetry() {
      try 
      {
        const reserveInfo = await this.$api("/api/resConsultDetail_new", { param: [this.origRCode] });
        if (reserveInfo && reserveInfo.length > 0) 
        {
          this.productId = reserveInfo[0].reqPdtCode;
          this.canRetry = true;
        }
      } 
      catch (error) 
      {
        console.error('fetchProductIdForRetry error:', error);
      }
    },

    // 외부결제(SP) 전용 - 관리자 화면이 보는 tb_spayinfo에 실패상태 반영
    async markSpayFailed() {
      try 
      {
        const res = await this.$api("/api/updSpayInfoFail", { param: [this.displayMessage, this.origRCode] });
        return res && res.affectedRows > 0;
      } 
      catch (error) 
      {
        console.error('markSpayFailed error:', error);
        return false;
      }
    },
  }
}
</script>